import styles from './PageContainer.module.scss';

/**
 * Props:
 *   children   the page body
 *   className  layout hook for the caller
 */
export const PageContainer = ({ children, className }) => {
  return <div className={`${styles.container}${className ? ` ${className}` : ''}`}>{children}</div>;
};
